const actions = {
    BRAND_MANUFACTURER_ADD_NEW: 'BRAND_MANUFACTURER_ADD_NEW',
    BRAND_MANUFACTURER_READ: 'BRAND_MANUFACTURER_READ',
    BRAND_MANUFACTURER_MAPPING_READ: "BRAND_MANUFACTURER_MAPPING_READ",
    BRAND_MANUFACTURER_READ_SUCCESS: 'BRAND_MANUFACTURER_READ_SUCCESS',
    BRAND_MANUFACTURER_MAPPING_READ_SUCCESS: "BRAND_MANUFACTURER_MAPPING_READ_SUCCESS",
    BRAND_MANUFACTURER_UPDATE: 'BRAND_MANUFACTURER_UPDATE',
    BRAND_MANUFACTURER_FIND_BY_ID: 'BRAND_MANUFACTURER_FIND_BY_ID',
    BRAND_MANUFACTURER_LIST_SUCCESS: 'BRAND_MANUFACTURER_LIST_SUCCESS',
    BRAND_MANUFACTURER_ITEM_SUCCESS: 'BRAND_MANUFACTURER_ITEM_SUCCESS',
    
    brandManufacturerAddNew:(history, dataObj) => ({ //Action creator function
      type: actions.BRAND_MANUFACTURER_ADD_NEW, //Action
      payload: { history, dataObj } //pass payload to action, we should pass as little data to action
    }),

    brandManufacturerRead:(readFilter, page) => ({ //Action creator function
      type: actions.BRAND_MANUFACTURER_READ, //Action
      payload: { readFilter, page } //pass payload to action, we should pass as little data to action
    }),
    brandManufacturerMappingRead:(readFilter, page) => ({ //Action creator function
      type: actions.BRAND_MANUFACTURER_MAPPING_READ, //Action
      payload: { readFilter, page } //pass payload to action, we should pass as little data to action
    }),
    onMappingPageChange: (readFilter, page) => ({
      type: actions.BRAND_MANUFACTURER_MAPPING_READ,
      payload: { readFilter, page }
    }),
    onPageChange: (readFilter, page) => ({
      type: actions.BRAND_MANUFACTURER_READ,
      payload: { readFilter, page }
    }),
    brandManufacturerReadSearchSuccess: (data, success, total_count, page, info) => ({
      type: actions.BRAND_MANUFACTURER_READ_SUCCESS,
      data,
      success,
      total_count,
      page,
      info
    }),
    brandManufacturerMappingReadSearchSuccess: (data, success, total_count, page, info) => ({
      type: actions.BRAND_MANUFACTURER_MAPPING_READ_SUCCESS,
      data,
      success,
      total_count,
      page,
      info
    }),

  };
  export default actions;